module.exports = __webpack_public_path__ + "media/AUDIO 18.982a70c8.mp3";